var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57275 5.99999C3.57275 5.33725 4.10594 4.79999 4.76366 4.79999H19.0546C19.7123 4.79999 20.2455 5.33725 20.2455 5.99999C20.2455 6.66273 19.7123 7.19999 19.0546 7.19999H4.76366C4.10594 7.19999 3.57275 6.66273 3.57275 5.99999Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57275 12C3.57275 11.3372 4.10594 10.8 4.76366 10.8H19.0546C19.7123 10.8 20.2455 11.3372 20.2455 12C20.2455 12.6627 19.7123 13.2 19.0546 13.2H4.76366C4.10594 13.2 3.57275 12.6627 3.57275 12Z",
    fill: "#0A0A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57275 18C3.57275 17.3372 4.10594 16.8 4.76366 16.8H19.0546C19.7123 16.8 20.2455 17.3372 20.2455 18C20.2455 18.6627 19.7123 19.2 19.0546 19.2H4.76366C4.10594 19.2 3.57275 18.6627 3.57275 18Z",
    fill: "#0A0A0A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.75bece3e5c4661c9dd31995d2e8e89f0.svg";
export { ForwardRef as ReactComponent };